/**
 * Shared PDP interactions for Purity Fields hybrid, story, and pulse templates
 * - Gallery thumbs
 * - Pack / quantity picker
 * - FAQ accordion
 * - Bundle discount redirect (optional)
 */
(function () {
  'use strict';

  const BUNDLE_DISCOUNTS = {
    'Buy 2 Get 1 FREE': 'BUY2GET1',
    'Buy 3 Get 2 FREE': 'BUY3GET2'
  };

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function initGallery(root) {
    const main = qs(root, '[data-pf-gallery-main]');
    const thumbs = qsa(root, '[data-pf-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const src = thumb.getAttribute('data-full-src');
        const img = qs(main, 'img');
        if (src && img) {
          img.src = src;
          img.srcset = '';
        }
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  function syncPackUI(scope, pack) {
    const priceEl = qs(scope, '[data-pf-price]');
    const btn = qs(scope, '[data-pf-add-btn]');
    const qtyInput = qs(scope, '[data-pf-bundle-qty]');
    const bundleProp = qs(scope, '[data-pf-bundle-name]');
    const originalProp = qs(scope, '[data-pf-bundle-regular]');
    const total = pack.getAttribute('data-total');
    const quantity = pack.getAttribute('data-quantity');
    const bundleName = pack.getAttribute('data-bundle-name');
    const regular = pack.getAttribute('data-regular');

    if (priceEl && total) {
      priceEl.textContent = '$' + parseFloat(total).toFixed(2);
    }
    if (btn && total) {
      const label = btn.getAttribute('data-label') || 'Add to Bag';
      btn.textContent = label + ' — $' + parseFloat(total).toFixed(2);
    }
    if (qtyInput && quantity) qtyInput.value = quantity;
    if (bundleProp) bundleProp.value = bundleName || '';
    if (originalProp && regular) originalProp.value = regular;
  }

  function initPacks(scope) {
    const packs = qsa(scope, '[data-pf-pack]');
    if (!packs.length) return;

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        packs.forEach(function (p) {
          p.classList.remove('is-active');
        });
        pack.classList.add('is-active');
        syncPackUI(scope, pack);
      });
    });

    const active = qs(scope, '[data-pf-pack].is-active') || packs[0];
    if (active) {
      active.classList.add('is-active');
      syncPackUI(scope, active);
    }
  }

  function initQty(scope) {
    const input = qs(scope, '[data-pf-qty-input]');
    const minus = qs(scope, '[data-pf-qty-minus]');
    const plus = qs(scope, '[data-pf-qty-plus]');
    if (!input) return;

    function clamp(n) {
      return Math.max(1, Math.min(99, n));
    }

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) - 1 || 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) + 1 || 1);
      });
    }
  }

  function initFaq(root) {
    qsa(root, '[data-pf-faq-item]').forEach(function (item) {
      const btn = qs(item, '[data-pf-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        const open = item.classList.contains('is-open');
        const list = item.parentElement;
        if (list) {
          qsa(list, '[data-pf-faq-item]').forEach(function (other) {
            other.classList.remove('is-open');
            const b = qs(other, '[data-pf-faq-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initBundleForm(form) {
    if (!form || form.dataset.pfBundleBound) return;
    form.dataset.pfBundleBound = '1';

    form.addEventListener('submit', async function (e) {
      const bundleProp = qs(form, '[data-pf-bundle-name]');
      const bundleName = bundleProp && bundleProp.value;
      const code = bundleName && BUNDLE_DISCOUNTS[bundleName];
      if (!code) return;

      e.preventDefault();
      const formData = new FormData(form);

      try {
        const addResponse = await fetch(window.Shopify && Shopify.routes
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (!addResponse.ok) throw new Error('add failed');
        window.location.href = '/cart?discount=' + encodeURIComponent(code);
      } catch (err) {
        console.error(err);
        form.submit();
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.pfPdpInit) return;
    root.dataset.pfPdpInit = '1';
    initGallery(root);
    initPacks(root);
    initQty(root);
    initFaq(root);
    qsa(root, '[data-pf-product-form]').forEach(initBundleForm);
  }

  function boot() {
    qsa(document, '[data-pf-pdp]').forEach(initRoot);
    // FAQ sections may sit outside buy root
    qsa(document, '[data-pf-faq-root]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
